import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
  Input,
  Modal,
  TimePicker,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
// Redux
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getClientid,
  getUserList,
  getMenuList,
  getUserInfo,
} from "redux/selectors";

import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
  differenceBetweenTwoTime,
  generateHourMinutesFromMinutes,
} from "utils/Date";
import COLORS from "common/Colors";
import { concat, find, get, includes, orderBy, reduce } from "lodash";
import Form1 from "react-bootstrap/Form";
import ViewMore from "organisms/ViewMore";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const Overtimewrap = styled.div`
  .change-view {
    color: #2d53da;
    border-radius: 10px;
  }
  .change-view:disabled {
    color: #e3e8fc !important;
  }
  .change-view: hover {
    background: #c5cff5;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 20px;
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    min-width: 200px;
    white-space: normal;
  }
  .stylediv {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .styleddiv {
    background: #26a4ff;
    color: white;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .stylebutton-yes {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    border: none;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    :hover {
      background: #198754;
      color: white;
    }
  }
  .stylebutton-no {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    border: none;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    :hover {
      background: #ff4d4f;
      color: white;
    }
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
  }
`;

const StyledButton2 = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;

const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 900px) {
    margin-left: -20px !important;
  }
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;

function OvertimeReport({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  userList,
  ClientId,
  menuList,
  userInfo,
}) {
  const { t, i18n } = useTranslation();

  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [overtimeList, setOvertimeList] = useState([]);
  const [overtimeList1, setOvertimeList1] = useState([]);
  const [CSVOvertimeList, setCSVOvertimeList] = useState([]);
  const [form] = Form.useForm();
  const [updateform] = Form.useForm();
  const csvLinkEl = useRef();
  const [ActionType, setActionType] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recordlist, setrecordlist] = useState([]);
  const [clickactionId, setclickactionId] = useState(0);
  const [filterList, setFilterList] = useState([]);
  const { TextArea } = Input;
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const pageTitleRef = useRef(null);
  const [pageTitleHeight, setPageTitleHeight] = useState(0);
  const [showSelection, setShowSelection] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isbulkApproveModalOpen, setIsbulkApproveModalOpen] = useState(false);
  const [isbulkDeclineModalOpen, setIsbulkDeclineModalOpen] = useState(false);
  const [scrollY, setScrollY] = useState();

  useEffect(() => {
    const updatePageTitleHeight = () => {
      const h = pageTitleRef?.current?.offsetHeight || 0;
      setPageTitleHeight(h);
    };
    updatePageTitleHeight();
    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(updatePageTitleHeight);
      if (pageTitleRef.current) ro.observe(pageTitleRef.current);
    }
    window.addEventListener("resize", updatePageTitleHeight);
    return () => {
      window.removeEventListener("resize", updatePageTitleHeight);
      if (ro && pageTitleRef.current) ro.unobserve(pageTitleRef.current);
    };
  }, [pageTitleRef]);

  useEffect(() => {
    const calculateScrollY = () => {
      const baseOffset = showSelection ? 310 : 250;
      const dynamicHeight = Math.max(
        120,
        window.innerHeight - pageTitleHeight - baseOffset
      );
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [pageTitleHeight, selectedRows]);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(
      month_list?.map((item) => {
        return { ...item, label: t(item?.label) };
      })
    );
  };

  const STAFF_LIST_ALL = (
    ActionType === "1" ? overtimeList : overtimeList1
  ).map((val) => ({
    userid: val.userid,
    name: val.fullname,
  }));

  for (let i = 0; i < STAFF_LIST_ALL.length; i++) {
    filterList.push(STAFF_LIST_ALL[i]);
  }

  const STAFF_LIST = [...new Set(filterList.map((a) => JSON.stringify(a)))].map(
    (a) => JSON.parse(a)
  );

  const overtimefilterdata = overtimeList.filter((val) => {
    if (form.getFieldValue("staff_name") === "") return val;
    else if (val?.userid === form.getFieldValue("staff_name")) return val;
  });

  const overtimefilterdata1 = overtimeList1.filter((val) => {
    if (form.getFieldValue("staff_name") === "") return val;
    else if (val?.userid === form.getFieldValue("staff_name")) return val;
  });

  const errorValidation = (values) => {
    let errors = {};
    if (!values.hours) errors.hours = t("This field is required");
    if (!values.notes) errors.notes = t("This field is required");
    return errors;
  };

  const [values, setValues] = useState({ hours: "00:00", notes: "" });
  const [dataIsCorrect, setDataiscorrect] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleFormsubmit = (event) => {
    event.preventDefault();
    setErrors(errorValidation(values));
    setDataiscorrect(true);
  };

  const resetValues = () => {
    setValues({ notes: "" });
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && dataIsCorrect) {
      update();
      setIsModalOpen(false);
      setTimeout(() => {
        getOvertimeReport();
      }, 2000);
    }
  }, [errors]);

  const showModal = () => setIsModalOpen(true);

  const handleCancel = () => {
    setIsModalOpen(false);
    resetValues();
  };

  console.log("recordlist", recordlist);

  const overtimeactionclick = (record) => {
    const diff = differenceBetweenTwoTime(
      record?.shiftendtime,
      record?.checkouttime
    );
    showModal();
    setrecordlist(record);
    setclickactionId(1);
    setValues({ hours: `${generateHourMinutesFromMinutes(diff)}` });
  };

  const overtimeactionclick1 = (record) => {
    showModal();
    setrecordlist(record);
    setclickactionId(2);
    setValues({ hours: "00:00" });
  };

  const update = async (record) => {
    setLoading(true);
    const diff = differenceBetweenTwoTime(
      recordlist?.shiftendtime,
      recordlist?.checkouttime
    );
    const filteruser = userList?.filter(
      (item) => item?.userid === recordlist?.userid
    );
    const notesValue = updateform?.getFieldValue("notes") || "";

    const { code } = await CALL_API(`overtime-action/${ClientId}`, "patch", {
      user_id: recordlist?.userid,
      employeeid: filteruser[0]?.employeeid,
      name: recordlist?.fullname,
      start_time: recordlist?.checkintime,
      end_time: recordlist?.checkouttime,
      shiftendtime: recordlist?.shiftendtime,
      departmentname: recordlist?.departmentname,
      duration: generateHourMinutesFromMinutes(diff),
      status_id: clickactionId,
      overtime_update: `${values?.hours}:00`,
      department_id: recordlist?.departmentid,
      checkin_id: recordlist?.userpunchactionid,
      date: recordlist?.checkindate,
      commands: values?.notes,
      reportingmanager: recordlist?.reportingmanager || "",
      bulkupdatelist:
        selectedRows?.length > 0
          ? selectedRows?.map((item) => {
              const itemDiff = differenceBetweenTwoTime(
                item?.shiftendtime,
                item?.checkouttime
              );
              const defaultOvertime = generateHourMinutesFromMinutes(itemDiff);
              const overtimeValue = item?.changedovertime || defaultOvertime;
              return {
                user_id: item?.userid,
                employeeid: userList?.find(
                  (user) => user?.userid === item?.userid
                )?.employeeid,
                name: item?.fullname,
                start_time: item?.checkintime,
                end_time: item?.checkouttime,
                shiftendtime: item?.shiftendtime,
                departmentname: item?.departmentname,
                duration: defaultOvertime,
                status_id: isbulkApproveModalOpen ? 1 : 2,
                overtime_update: isbulkApproveModalOpen
                  ? `${overtimeValue}:00`
                  : "00:00:00",
                department_id: item?.departmentid,
                checkin_id: item?.userpunchactionid,
                date: item?.checkindate,
                commands: notesValue,
                reportingmanager: item?.reportingmanager || "",
                checkouttype: item?.checkouttype || "",
                punchoutstatus: item?.punchoutstatus || "",
              };
            })
          : [],
    });

    if (isbulkApproveModalOpen || isbulkDeclineModalOpen) {
      if (isbulkApproveModalOpen) {
        message?.success(t("Bulk Approved successfully"));
      } else {
        message?.success(t("Bulk Declined successfully"));
      }
      updateform.resetFields();
      setIsbulkApproveModalOpen(false);
      setIsbulkDeclineModalOpen(false);
      setShowSelection(false);
      setSelectedRowKeys([]);
      setSelectedRows([]);
      getOvertimeReport();
    }

    resetValues();
    setLoading(false);
  };

  const CSVHeaders = [
    { label: t("Employee ID") },
    { label: t("Employee Name") },
    { label: t("Department") },
    { label: t("Checkin Date") },
    { label: t("Checkin Time") },
    { label: t("Checkout Time") },
    { label: t("Duration (Hours)") },
    { label: t("Late time (Hours)") },
    ActionType === "2" && [
      { label: t("Overtime Amended") },
      { label: t("Comments") },
    ],
  ];

  const columns = [
    {
      title: t("Employee ID"),
      dataIndex: ActionType === "1" ? "userid" : "employeeId",
      key: ActionType === "1" ? "userid" : "employeeId",
      width: 200,
      render: (userId) => {
        const filteruser = userList?.filter((item) => item?.userid === userId);
        return ActionType === "1" ? filteruser[0]?.employeeid : userId;
      },
    },
    {
      title: t("Employee Name"),
      dataIndex: ActionType === "1" ? "fullname" : "fullName",
      key: ActionType === "1" ? "fullname" : "fullName",
      width: 200,
    },
    {
      title: t("Department"),
      dataIndex: ActionType === "1" ? "departmentname" : "departmentName",
      key: ActionType === "1" ? "departmentname" : "departmentName",
      width: 200,
    },
    {
      title: t("Checkin Date"),
      dataIndex: ActionType === "2" ? "overtimeDate" : "checkindate",
      key: ActionType === "2" ? "overtimeDate" : "checkindate",
      width: 200,
      render: (checkinDate) => moment(checkinDate).format("DD MMM YYYY"),
    },
    {
      title: t("Checkin Day"),
      dataIndex: ActionType === "2" ? "overtimeDate" : "checkindate",
      key: ActionType === "2" ? "overtimeDate" : "checkindate",
      width: 200,
      render: (checkinDate) => moment(checkinDate).format("dddd"),
    },
    {
      title: t("Checkin Time"),
      dataIndex: ActionType === "2" ? "startTime" : "checkintime",
      key: ActionType === "2" ? "startTime" : "checkintime",
      width: 200,
      render: (time) => moment(time, "HH:mm:ss").format("HH:mm"),
    },
    {
      title: t("Checkout Date"),
      dataIndex: ActionType === "2" ? "overtimeDate" : "checkoutdate",
      key: ActionType === "2" ? "overtimeDate" : "checkoutdate",
      width: 200,
      render: (checkoutDate) => moment(checkoutDate).format("DD MMM YYYY"),
    },
    {
      title: t("Checkout Day"),
      dataIndex: ActionType === "2" ? "overtimeDate" : "checkoutdate",
      key: ActionType === "2" ? "overtimeDate" : "checkoutdate",
      width: 200,
      render: (checkoutDate) => moment(checkoutDate).format("dddd"),
    },
    {
      title: t("Checkout Time"),
      dataIndex: ActionType === "1" ? "checkouttime" : "endTime",
      key: ActionType === "1" ? "checkouttime" : "endTime",
      width: 200,
      render: (time) => moment(time, "HH:mm:ss").format("HH:mm"),
    },
    {
      title: t("Overtime Duration (Hours)"),
      dataIndex: "overtimeDuration",
      key: "overtimeDuration",
      width: 200,
      render: (_, record) => {
        if (ActionType === "1") {
          const diff = differenceBetweenTwoTime(
            record?.shiftendtime,
            record?.checkouttime
          );
          return generateHourMinutesFromMinutes(diff);
        } else {
          return record?.overtimeDuration;
        }
      },
    },
  ];

  if (
    ActionType === "1" &&
    Menulist?.find(
      (item) =>
        item?.key === "reports" &&
        item?.subMenu.find(
          (subItem) =>
            subItem?.key === "overtime-report" && subItem?.permission.edit
        )
    )
  ) {
    columns.push({
      title: t("Action"),
      dataIndex: "action",
      key: "overtimeDuration",
      width: 200,
      render: (_, record) => (
        <Row
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Row>
            <Col>
              <button
                className="stylebutton-yes"
                onClick={() => overtimeactionclick(record)}
              >
                {t("Yes")}
              </button>
            </Col>
            <Col>
              <button
                className="stylebutton-no"
                onClick={() => overtimeactionclick1(record)}
              >
                {t("No")}
              </button>
            </Col>
          </Row>
        </Row>
      ),
    });
  }

  if (ActionType === "2") {
    columns.push(
      {
        title: t("Action"),
        dataIndex: "action",
        key: "overtimeDuration",
        width: 200,
        render: (_, record) => (
          <Row
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {ActionType === "2" && (
              <Row>
                {record?.statusId === 1 ? (
                  <Col>
                    <div
                      style={{ background: "#198754" }}
                      className="styleddiv"
                    >
                      {t("Yes")}
                    </div>
                  </Col>
                ) : (
                  <Col>
                    <div
                      style={{ background: "#FF4D4F" }}
                      className="styleddiv"
                    >
                      {t("No")}
                    </div>
                  </Col>
                )}
              </Row>
            )}
          </Row>
        ),
      },
      {
        title: t("Overtime Amended"),
        dataIndex: "overtimeUpdate",
        key: "overtimeUpdate",
        width: 200,
      },
      {
        title: t("Comments"),
        dataIndex: "commands",
        key: "commands",
        width: 200,
        className: "normal-column",
        render: (reason) => <ViewMore value={reason} />,
      }
    );
  }

  useEffect(() => {
    list();
    getOvertimeReport();
  }, [
    selectedDepartmentId,
    ActionType,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);

  useEffect(() => {
    form.resetFields();
    list();
  }, [i18n.language]);

  const getOvertimeReport = async () => {
    return new Promise(async (resolve, reject) => {
      setOvertimeList([]);
      const { start_date, end_date, duration_type, month, department } =
        form.getFieldsValue();
      setDisplayTableLoader(true);
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      if (ActionType === "1") {
        const { code, overtimeList = [] } = await CALL_API(
          `overtime-report/${ClientId}`,
          "post",
          {
            department: [""],
            start_date: getMySqlDate(
              duration_type === 2 ? startDateOfMonth : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2 ? lastDateOfMonth : end_date
            ),
            reportingmanager: userInfo?.userid,
          }
        );
        setDisplayTableLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setOvertimeList(orderBy(overtimeList, ["checkindatetime"], ["desc"]));
        }
      } else {
        const { code, overTimeActionList = [] } = await CALL_API(
          `overtime-action/${ClientId}`,
          "post",
          {
            departmentId: [""],
            start_date: getMySqlDate(
              duration_type === 2 ? startDateOfMonth : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2 ? lastDateOfMonth : end_date
            ),
            reportingmanager: userInfo?.userid,
          }
        );
        setDisplayTableLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setOvertimeList1(
            orderBy(overTimeActionList, ["checkindatetime"], ["desc"])
          );
        }
      }
    });
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const prepareCSV = async (event, done) => {
    if (ActionType === "1") {
      if (overtimefilterdata?.length > 0) {
        setCSVOvertimeList(
          reduce(
            overtimefilterdata,
            function (result, record) {
              const filteruser = userList?.filter(
                (item) => item?.userid === record?.userid
              );
              const {
                date_th: day,
                shortMonthName,
                year,
              } = dateInDetail(record.checkindate);
              result.push({
                [t("Employee ID")]: filteruser[0]?.employeeid,
                [t("Employee Name")]: record?.fullname,
                [t("Department")]: record?.departmentname,
                [t("Checkin Date")]: `${day} ${shortMonthName} ${year}`,
                [t("Checkin Day")]: `${moment(record.checkindate).format(
                  "dddd"
                )}`,
                [t("Checkin Time")]: record?.checkintime,
                [t("Checkout Date")]: `${day} ${shortMonthName} ${year}`,
                [t("Checkout Day")]: `${moment(record.checkoutdate).format(
                  "dddd"
                )}`,
                [t("Checkout Time")]: record?.checkouttime,
                [t("Duration (Hours)")]: generateHourMinutesFromMinutes(
                  differenceBetweenTwoTime(
                    record?.shiftendtime,
                    record?.checkouttime
                  )
                ),
              });
              return result;
            },
            []
          )
        );
        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error(t("No data available to download."));
      }
    } else {
      if (overtimefilterdata1?.length > 0) {
        setCSVOvertimeList(
          reduce(
            overtimefilterdata1,
            function (result, record) {
              const {
                date_th: day,
                shortMonthName,
                year,
              } = dateInDetail(record.overtimeDate);
              result.push({
                [t("Employee ID")]: record?.employeeId,
                [t("Employee Name")]: record?.fullName,
                [t("Department")]: record?.departmentName,
                [t("Checkin Date")]: `${day} ${shortMonthName} ${year}`,
                [t("Checkin Day")]: `${moment(record.overtimeDate).format(
                  "dddd"
                )}`,
                [t("Checkin Time")]: record?.startTime,
                [t("Checkout Date")]: `${day} ${shortMonthName} ${year}`,
                [t("Checkout Day")]: `${moment(record.overtimeDate).format(
                  "dddd"
                )}`,
                [t("Checkout Time")]: record?.endTime,
                [t("Duration (Hours)")]: record?.overtimeDuration,
                [t("Action")]: record?.statusId === 1 ? t("Yes") : t("No"),
                [t("Overtime Amended")]: record?.overtimeUpdate,
                [t("Comments")]: record?.commands,
              });
              return result;
            },
            []
          )
        );
        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error(t("No data available to download."));
      }
    }
  };

  const paginationOptions = {
    showTotal: (total, range) =>
      `${range[0]}-${range[1]} ${t("of")} ${total} ${t("items")}`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const { hours, notes } = values;

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
    columnWidth: 50,
  };

  const footerStyle = {
    position: "sticky",
    bottom: -25,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "20px -24px -20px -20px",
    zIndex: 10,
  };

  return (
    <Overtimewrap>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} className="align-left">
          <h6 className="pt-2">{t("Overtime")}</h6>
        </Col>
        <Col xs={24} sm={24} md={12} className="align-right">
          <StyledButtonoutlined
            onClick={prepareCSV}
            disabled={
              showSelection ||
              (ActionType === "1"
                ? overtimefilterdata.length === 0
                : overtimefilterdata1.length === 0)
            }
          >
            {t("Export CSV file")}
          </StyledButtonoutlined>
          <CSVLink
            header={CSVHeaders}
            data={CSVOvertimeList}
            filename={"overtime-report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>
      <Row className="page-title" ref={pageTitleRef}>
        <Col
          xs={24}
          sm={24}
          md={20}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
              }}
              onFinish={getOvertimeReport}
            >
              <Form.Item
                name="duration_type"
                rules={[{ required: true, message: "" }]}
              >
                <Select
                  placeholder={t("Select...")}
                  options={REPORT_DURATION_TYPES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              <Select
                style={{ marginRight: "20px" }}
                className="selectbox"
                placeholder={t("Employee type")}
                defaultValue={"1"}
                options={[
                  { value: "1", label: t("Waiting For Action") },
                  { value: "2", label: t("Action history") },
                ]}
                onChange={(e) => setActionType(e)}
                getPopupContainer={() => containerRef.current}
              />
              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder={t("Start date")}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder={t("End date")}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      name="month"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Select
                        placeholder={t("Select...")}
                        options={monthList}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[{ required: false, message: "" }]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.name ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.name ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.name ?? "").toLowerCase())
                  }
                  placeholder={t("Select Employee")}
                  options={concat(
                    { userid: "", name: t("All Employee") },
                    STAFF_LIST
                  )}
                  fieldNames={{ label: "name", value: "userid" }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        {ActionType === "1" && (
          <Col xs={24} sm={4} md={4} className="align-right">
            <Button
              type="link"
              className="change-view"
              onClick={() => setShowSelection(true)}
              disabled={showSelection || overtimefilterdata.length === 0}
            >
              {t("Multi Select")}
            </Button>
          </Col>
        )}
      </Row>
      <br />
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={
            ActionType === "1" ? overtimefilterdata : overtimefilterdata1
          }
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="userpunchactionid"
          scroll={{ y: scrollY }}
          style={{ minHeight: scrollY + 55 }}
          pagination={
            (ActionType === "1" ? overtimefilterdata : overtimefilterdata1)
              .length > 100
              ? paginationOptions
              : false
          }
          rowSelection={showSelection ? rowSelection : null}
        />
      </Spin>
      {showSelection && (
        <div style={footerStyle}>
          <ButtonOutlined
            className="border-0"
            onClick={() => {
              updateform.resetFields();
              setIsbulkApproveModalOpen(false);
              setIsbulkDeclineModalOpen(false);
              setShowSelection(false);
              setSelectedRowKeys([]);
              setSelectedRows([]);
            }}
          >
            {t("Cancel")}
          </ButtonOutlined>
          <ButtonOutlined
            onClick={() => setIsbulkDeclineModalOpen(true)}
            disabled={selectedRows?.length === 0}
          >
            {t("Decline")}
          </ButtonOutlined>
          <ButtonFilled
            type="primary"
            htmlType="submit"
            onClick={() => setIsbulkApproveModalOpen(true)}
            disabled={selectedRows?.length === 0}
          >
            {t("Approve")}
          </ButtonFilled>
        </div>
      )}
      <Modal
        title={t("Add Note")}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={false}
        keyboard={false}
      >
        <div>
          <Form1.Group>
            {clickactionId === 1 && (
              <>
                <Form1.Label
                  style={{ Font: "normal normal normal 16px/19px Lato" }}
                >
                  {t("Duration:")}
                </Form1.Label>{" "}
                <br />
                <Input
                  style={{
                    width: "100%",
                    border: "1px solid #9B9B9B",
                    marginBottom: "10px",
                  }}
                  placeholder=""
                  type="time"
                  name="hours"
                  value={hours}
                  onChange={handleChange}
                />
                {errors.hours && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "10px",
                      marginBottom: "-5px",
                    }}
                  >
                    {errors.hours}
                  </p>
                )}
                <br />
              </>
            )}
            <Form1.Label
              style={{ Font: "normal normal normal 16px/19px Lato" }}
            >
              {t("Note:")}
            </Form1.Label>{" "}
            <br />
            <TextArea
              style={{ width: "100%", border: "1px solid #9B9B9B" }}
              placeholder=""
              type="text"
              name="notes"
              value={notes}
              rows={4}
              maxLength={500}
              onChange={handleChange}
            />
            {errors.notes && (
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "-5px" }}
              >
                {errors.notes}
              </p>
            )}
          </Form1.Group>
          <Col
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "right",
            }}
          >
            <ButtonFilled onClick={handleFormsubmit}>{t("Save")}</ButtonFilled>
          </Col>
        </div>
      </Modal>
      <Modal
        title={
          isbulkApproveModalOpen ? t("Approve Overtime") : t("Decline Overtime")
        }
        open={isbulkApproveModalOpen || isbulkDeclineModalOpen}
        onCancel={() => {
          updateform.resetFields();
          setIsbulkApproveModalOpen(false);
          setIsbulkDeclineModalOpen(false);
          setShowSelection(false);
          setSelectedRowKeys([]);
          setSelectedRows([]);
        }}
        footer={null}
        width={isbulkApproveModalOpen ? 900 : 600}
        destroyOnClose
      >
        <Row gutter={24}>
          {isbulkApproveModalOpen && (
            <Col xs={24} md={11}>
              <div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1.5fr 1.5fr 40px",
                    padding: "8px 12px",
                    fontWeight: 600,
                    fontSize: 13,
                    color: "#666",
                    borderTopLeftRadius: 6,
                    borderTopRightRadius: 6,
                    borderBottom: "1px solid #e8e8e8",
                    marginBottom: 2,
                    background: "#e8e8e8",
                  }}
                >
                  <div>{t("Name")}</div>
                  <div>{t("Employee ID")}</div>
                  <div>{t("Duration")}</div>
                </div>
                <div style={{ maxHeight: 220, overflowY: "auto" }}>
                  {selectedRows.map((item, index) => (
                    <div style={{ background: "#edf0ff" }} key={index}>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 1.5fr 1.5fr 40px",
                          alignItems: "center",
                          background: "#edf0ff",
                          padding: "12px",
                          fontSize: 14,
                          maxHeight: 320,
                          overflowY: "auto",
                        }}
                      >
                        <div style={{ color: "#1a1a1a", fontWeight: 500 }}>
                          {item.fullname}
                        </div>
                        <div style={{ color: "#666" }}>
                          {userList?.find((val) => val?.userid === item.userid)
                            ?.employeeid || "EM12345"}
                        </div>
                        <div style={{ color: "#666" }}>
                          <TimePicker
                            format="HH:mm"
                            size="small"
                            style={{ width: 100 }}
                            showNow={false}
                            addon={() => null}
                            value={() => {
                              if (item?.changedovertime) {
                                return dayjs(item.changedovertime, "HH:mm");
                              } else {
                                const diff = differenceBetweenTwoTime(
                                  item?.shiftendtime,
                                  item?.checkouttime
                                );
                                const formatted =
                                  generateHourMinutesFromMinutes(diff);
                                return formatted
                                  ? dayjs(formatted, "HH:mm")
                                  : null;
                              }
                            }}
                            onSelect={(time) => {
                              setSelectedRows((prev) =>
                                prev.map((row) =>
                                  row.userpunchactionid ===
                                  item.userpunchactionid
                                    ? {
                                        ...row,
                                        changedovertime: time
                                          ? time.format("HH:mm")
                                          : "",
                                      }
                                    : row
                                )
                              );
                            }}
                            getPopupContainer={() => containerRef.current}
                          />
                        </div>
                        <div style={{ textAlign: "center" }}></div>
                      </div>
                      <hr
                        style={{
                          margin: "0px 10px",
                          background: "#ffffff",
                          height: 2,
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          )}
          <Col xs={24} md={isbulkApproveModalOpen ? 13 : 24}>
            <Form form={updateform} layout="vertical" onFinish={update}>
              <Form.Item
                label={
                  isbulkApproveModalOpen ? t("Notes") : t("Decline reason")
                }
                name="notes"
                rules={[
                  { required: true, message: t("This field is required") },
                  { max: 250, message: t("Maximum 250 characters allowed") },
                ]}
              >
                <Input.TextArea
                  placeholder={t("Enter notes")}
                  rows={4}
                  maxLength={250}
                  showCount={{
                    formatter: ({ count }) => t("Maximum 250 characters"),
                  }}
                />
              </Form.Item>
              <div style={{ textAlign: "right", marginTop: "100px" }}>
                <Button
                  onClick={() => {
                    updateform.resetFields();
                    setIsbulkApproveModalOpen(false);
                    setIsbulkDeclineModalOpen(false);
                    setShowSelection(false);
                    setSelectedRowKeys([]);
                    setSelectedRows([]);
                  }}
                  style={{ marginRight: 8 }}
                >
                  {t("Cancel")}
                </Button>
                <Button type="primary" loading={loading} htmlType="submit">
                  {isbulkApproveModalOpen ? t("Approve") : t("Decline")}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Modal>
    </Overtimewrap>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  menuList: getMenuList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(OvertimeReport);
